module.exports = __webpack_public_path__ + "static/media/header-googlePlay.0a4dc1a9.svg";